export default {
  translation: {
    common: {
      duplicate: 'Dupliceren',
      duplicateConfirm: 'Weet je zeker dat je wilt dupliceren?',
      delete: 'Delete',
      deleteModalTitle: 'Are you sure to delete this item?',
      ok: 'OK',
      cancel: 'Annuleren',
      total: 'Totaal',
      rename: 'Hernoemen',
      name: 'Name',
      email: 'E-mail',
      save: 'Opslaan',
      namePlaceholder: 'Voer een naam in',
      next: 'Volgende',
      create: 'Create',
      edit: 'Bewerken',
      upload: 'Upload',
      english: 'English',
      portugueseBr: 'Portuguese (Brazil)',
      chinese: 'Simplified Chinese',
      traditionalChinese: 'Traditional Chinese',
      language: 'Language',
      languageMessage: 'Please input your language!',
      languagePlaceholder: 'select your language',
      copy: 'Kopiëren',
      copied: 'Gekopieerd',
      comingSoon: 'Binnenkort beschikbaar',
      download: 'Download',
      reload: 'Vernieuwen',
      close: 'Sluiten',
      preview: 'Voorbeeld',
      move: 'Verplaatsen',
      warn: 'Warn',
      action: 'Action',
      s: 'S',
      pleaseSelect: 'Please select',
      pleaseInput: 'Please input',
      submit: 'Submit',
      embedIntoSite: 'Embed into webpage',
      previousPage: 'Previous',
      nextPage: 'Next',
      // Share management translations
      managedShares: 'Beheerde Shares',
      managedSharesDescription:
        'Maak beheerde shareversies met unieke auth-tokens voor tracking en controle.',
      createShare: 'Share Aanmaken',
      editShare: 'Share Bewerken',
      deleteShare: 'Verwijderen',
      deleteShareConfirm: 'Weet je zeker dat je deze share wilt verwijderen?',
      enableShare: 'Inschakelen',
      disableShare: 'Uitschakelen',
      regenerateToken: 'Token Vernieuwen',
      regenerateTokenConfirm:
        'Dit zal de huidige token ongeldig maken. Doorgaan?',
      shareName: 'Naam',
      shareNamePlaceholder: 'bijv., Productie Website',
      shareNameRequired: 'Voer een naam in',
      shareDescription: 'Beschrijving',
      shareDescriptionPlaceholder:
        'Optionele beschrijving voor deze shareversie',
      shareDestination: 'Doel URL',
      shareDestinationPlaceholder: 'bijv., https://example.com',
      authToken: 'Auth Token',
      noShares: 'Nog geen beheerde shares',
      createFirstShare: 'Maak Je Eerste Share',
      active: 'Actief',
      inactive: 'Inactief',
      selected: 'Geselecteerd',
      shareCreated: 'Share succesvol aangemaakt',
      shareUpdated: 'Share succesvol bijgewerkt',
      shareDeleted: 'Share succesvol verwijderd',
      shareEnabled: 'Share ingeschakeld',
      shareDisabled: 'Share uitgeschakeld',
      tokenRegenerated: 'Token succesvol vernieuwd',
      tokenCopied: 'Token gekopieerd!',
      copyToken: 'Token Kopiëren',
      usingShare: 'Gebruikmakend van share: ',
      forEmbedCode: ' voor embed code generatie',
      useDefault: 'Standaard gebruiken',
      usingManagedShare: 'Gebruik: ',
      embedSettings: 'Embed Instellingen',
      shareCreateFailed: 'Share aanmaken mislukt',
      shareUpdateFailed: 'Share bijwerken mislukt',
      shareDeleteFailed: 'Share verwijderen mislukt',
      shareToggleFailed: 'Share status wijzigen mislukt',
      tokenRegenerateFailed: 'Token vernieuwen mislukt',
    },
    login: {
      login: 'Inloggen',
      signUp: 'Registreer',
      loginDescription: 'Welkom terug bij RAGFlow!',
      registerDescription: 'Glad to have you on board!',
      emailLabel: 'Email',
      emailPlaceholder: 'Voer een email in',
      passwordLabel: 'Wachtwoord',
      passwordPlaceholder: 'Voer een wachtwoord in',
      rememberMe: 'Onthoud mij',
      signInTip: 'Nog geen account?',
      signUpTip: 'Al een account?',
      nicknameLabel: 'Nickname',
      nicknamePlaceholder: 'Voer een gebruikersnaam in',
      register: 'Maak een account aan',
      continue: 'Verder',
      title: 'Start building your smart assistants.',
      description:
        'Sign up for free to explore top RAG technology. Create knowledge bases and AIs to empower your business.',
      review: 'from 500+ reviews',
    },
    header: {
      knowledgeBase: 'Kennisbank',
      chat: 'Chat',
      register: 'Registreer',
      signin: 'Login in',
      home: 'Home',
      setting: 'Gebruikers instellingen',
      logout: 'Log uit',
      fileManager: 'Bestanden',
      flow: 'Agent',
      search: 'Zoeken',
    },
    knowledgeList: {
      welcome: 'Welkom terug',
      description: 'Welke kennisbank wil je vandaag gebruiken?',
      createKnowledgeBase: 'Nieuwe kennisbank',
      name: 'Naam',
      namePlaceholder: 'Voer een naam in!',
      doc: 'Documenten',
      searchKnowledgePlaceholder: 'Zoeken',
      transferInProgress:
        'Overdracht bezig. Deze kennisbank wordt op de achtergrond verplaatst, dus controleer deze pagina later opnieuw.',
      noMoreData: `Dat is alles.`,
    },
    knowledgeDetails: {
      dataset: 'Dataset',
      testing: 'Retrieval testing',
      files: 'files',
      configuration: 'Configuration',
      knowledgeGraph: 'Knowledge graph',
      name: 'Name',
      namePlaceholder: 'Please input name!',
      doc: 'Docs',
      datasetDescription:
        '😉 Please wait for your files to finish parsing before starting an AI-powered chat.',
      addFile: 'Add file',
      searchFiles: 'Search your files',
      localFiles: 'Local files',
      emptyFiles: 'Create empty file',
      webCrawl: 'Web Crawl',
      chunkNumber: 'Chunk Number',
      uploadDate: 'Upload Date',
      chunkMethod: 'Chunk Method',
      enabled: 'Enable',
      disabled: 'Disable',
      action: 'Action',
      parsingStatus: 'Parsing Status',
      processBeginAt: 'Begin at',
      processDuration: 'Duration',
      progressMsg: 'Progress',
      testingDescription:
        'Conduct a retrieval test to check if RAGFlow can recover the intended content for the LLM. If you have adjusted the default settings, such as keyword similarity weight or similarity threshold, to achieve the optimal results, be aware that these changes will not be automatically saved. You must apply them to your chat assistant settings or the **Retrieval** agent component settings.',
      similarityThreshold: 'Similarity threshold',
      similarityThresholdTip:
        'RAGFlow employs either a combination of weighted keyword similarity and weighted vector cosine similarity, or a combination of weighted keyword similarity and weighted reranking score during retrieval. This parameter sets the threshold for similarities between the user query and chunks. Any chunk with a similarity score below this threshold will be excluded from the results.',
      vectorSimilarityWeight: 'Keyword similarity weight',
      vectorSimilarityWeightTip:
        'This sets the weight of keyword similarity in the combined similarity score, either used with vector cosine similarity or with reranking score. The total of the two weights must equal 1.0.',
      testText: 'Test text',
      testTextPlaceholder: 'Input your question here!',
      testingLabel: 'Testing',
      similarity: 'Hybrid similarity',
      termSimilarity: 'Term similarity',
      vectorSimilarity: 'Vector similarity',
      hits: 'Hits',
      view: 'View',
      filesSelected: 'Files selected',
      upload: 'Upload',
      run: 'Parse',
      runningStatus0: 'PENDING',
      runningStatus1: 'PARSING',
      runningStatus2: 'CANCELED',
      runningStatus3: 'SUCCESS',
      runningStatus4: 'FAIL',
      pageRanges: 'Page Ranges',
      pageRangesTip:
        'Range of pages to be parsed; pages outside this range will not be processed.',
      fromPlaceholder: 'from',
      fromMessage: 'Missing start page number',
      toPlaceholder: 'to',
      toMessage: 'Missing end page number (excluded)',
      layoutRecognize: 'Document parser',
      layoutRecognizeTip:
        'Use a visual model for PDF layout analysis to effectively locate document titles, text blocks, images, and tables. If the naive option is chosen, only the plain text in the PDF will be retrieved. Please note that this option currently works ONLY for PDF documents.',
      taskPageSize: 'Task page size',
      taskPageSizeMessage: 'Please input your task page size!',
      taskPageSizeTip: `During layout recognition, a PDF file is split into chunks and processed in parallel to increase processing speed. This parameter sets the size of each chunk. A larger chunk size reduces the likelihood of splitting continuous text between pages.`,
      addPage: 'Add page',
      greaterThan: 'The current value must be greater than to!',
      greaterThanPrevious:
        'The current value must be greater than the previous to!',
      selectFiles: 'Select files',
      changeSpecificCategory: 'Change specific category',
      uploadTitle: 'Drag and drop your file here to upload',
      uploadDescription:
        'Supports single or bulk file upload. Files must not exceed 10MB each, with a maximum of 128 files.',
      chunk: 'Chunk',
      bulk: 'Bulk',
      cancel: 'Cancel',
      rerankModel: 'Rerank model',
      rerankPlaceholder: 'Please select',
      rerankTip: `If left empty, RAGFlow will use a combination of weighted keyword similarity and weighted vector cosine similarity; if a rerank model is selected, a weighted reranking score will replace the weighted vector cosine similarity. Please be aware that using a rerank model will significantly increase the system's response time.`,
      topK: 'Top-K',
      topKTip: `K chunks will be sent into the rerank model.`,
      delimiter: `Delimiters`,
      delimiterTip:
        'A delimiter or separator can consist of one or multiple special characters. If it is multiple characters, ensure they are enclosed in backticks( ``). For example, if you configure your delimiters like this: \n`##`;, then your texts will be separated at line breaks, double hash symbols (##), or semicolons.',
      html4excel: 'Excel to HTML',
      html4excelTip: `When enabled, the spreadsheet will be parsed into HTML tables, and at most 256 rows for one table. Otherwise, it will be parsed into key-value pairs by row.`,
      autoKeywords: 'Auto-keyword',
      autoKeywordsTip: `Automatically extract N keywords for each chunk to increase their ranking for queries containing those keywords. You can check or update the added keywords for a chunk from the chunk list. Be aware that extra tokens will be consumed by the LLM specified in 'System model settings'.`,
      autoQuestions: 'Auto-question',
      autoQuestionsTip: `Automatically extract N questions for each chunk to increase their ranking for queries containing those questions. You can check or update the added questions for a chunk from the chunk list. This feature will not disrupt the chunking process if an error occurs, except that it may add an empty result to the original chunk. Be aware that extra tokens will be consumed by the LLM specified in 'System model settings'.`,
      redo: 'Do you want to clear the existing {{chunkNum}} chunks?',
      qaReparseWarning: '⚠️ WAARSCHUWING: Q&A Document Opnieuw Analyseren',
      qaReparseWarningContent:
        'Dit document gebruikt de Q&A-chunkmethode. Het opnieuw analyseren VERWIJDERT alle bestaande chunks, inclusief handmatig toegevoegde Q&A-paren. Deze actie kan niet ongedaan worden gemaakt.',
      qaReparseFirstConfirm:
        'Ik begrijp dat handmatig toegevoegde chunks verloren gaan',
      qaReparseSecondConfirm:
        'Ja, doorgaan met opnieuw analyseren en alle chunks verwijderen',
      qaParserChangeWarning: '⚠️ WAARSCHUWING: Q&A-Chunkmethode Wijzigen',
      qaParserChangeWarningContent:
        'Dit document gebruikt momenteel de Q&A-chunkmethode en kan handmatig toegevoegde Q&A-paren bevatten. Het wijzigen van de chunkmethode zal ertoe leiden dat alle bestaande chunks worden gewist wanneer opnieuw wordt geanalyseerd. Deze actie kan niet ongedaan worden gemaakt.',
      qaParserChangeConfirm:
        'Ik begrijp dat chunks zullen worden gewist bij opnieuw analyseren',
      setMetaData: 'Set Meta Data',
      pleaseInputJson: 'Please enter JSON',
      documentMetaTips: `<p>The meta data is in Json format(it's not searchable). It will be added into prompt for LLM if any chunks of this document are included in the prompt.</p>
<p>Examples:</p>
<b>The meta data is:</b><br>
<code>
  {
      "Author": "Alex Dowson",
      "Date": "2024-11-12"
  }
</code><br>
<b>The prompt will be:</b><br>
<p>Document: the_name_of_document</p>
<p>Author: Alex Dowson</p>
<p>Date: 2024-11-12</p>
<p>Relevant fragments as following:</p>
<ul>
<li>  Here is the chunk content....</li>
<li>  Here is the chunk content....</li>
</ul>
`,
      metaData: 'Meta data',
      deleteDocumentConfirmContent:
        'The document is associated with the knowledge graph. After deletion, the related node and relationship information will be deleted, but the graph will not be updated immediately. The update graph action is performed during the process of parsing the new document that carries the knowledge graph extraction task.',
      plainText: 'Naive',
      reRankModelWaring: 'Re-rank model is very time consuming.',
    },
    knowledgeConfiguration: {
      titleDescription:
        'Update your knowledge base configuration here, particularly the chunk method.',
      name: 'Knowledge base name',
      photo: 'Knowledge base photo',
      description: 'Description',
      language: 'Document language',
      languageMessage: 'Please input your language!',
      languagePlaceholder: 'Please input your language!',
      permissions: 'Permissions',
      embeddingModel: 'Embedding model',
      chunkTokenNumber: 'Chunk token number',
      chunkTokenNumberMessage: 'Chunk token number is required',
      embeddingModelTip:
        'The model that converts chunks into embeddings. It cannot be changed once the knowledge base has chunks. To switch to a different embedding model, you must delete all existing chunks in the knowledge base.',
      permissionsTip:
        "If set to 'Team', all team members will be able to manage the knowledge base.",
      chunkTokenNumberTip:
        'It sets the token threshold for a chunk. A paragraph with fewer tokens than this threshold will be combined with the following paragraph until the token count exceeds the threshold, at which point a chunk is created.',
      chunkMethod: 'Chunk method',
      chunkMethodTip: 'View the tips on the right.',
      upload: 'Upload',
      english: 'English',
      chinese: 'Chinese',
      portugueseBr: 'Portuguese (Brazil)',
      embeddingModelPlaceholder: 'Please select a embedding model.',
      chunkMethodPlaceholder: 'Please select a chunk method.',
      save: 'Opslaan',
      me: 'Only me',
      team: 'Team',
      cancel: 'Cancel',
      methodTitle: 'Chunk method description',
      methodExamples: 'Examples',
      methodExamplesDescription:
        'The following screenshots are provided for clarity.',
      dialogueExamplesTitle: 'view',
      methodEmpty:
        'This will display a visual explanation of the knowledge base categories',
      book: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      For each book in PDF, please set the <i>page ranges</i> to remove unwanted information and reduce analysis time.</p>`,
      laws: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      Legal documents typically follow a rigorous writing format. We use text feature to identify split point. 
      </p><p>
      The chunk has a granularity consistent with 'ARTICLE', ensuring all upper level text is included in the chunk.
      </p>`,
      manual: `<p>Only <b>PDF</b> is supported.</p><p>
      We assume that the manual has a hierarchical section structure, using the lowest section titles as basic unit for chunking documents. Therefore, figures and tables in the same section will not be separated, which may result in larger chunk sizes.
      </p>`,
      custom: `<p>Supported file formats are <b>PDF & DOCX</br></p>
      <p>This method is a custom chunking method as implemented by Techletes & Realworld Systems.</p>`,
      naive: `<p>Supported file formats are <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML, HTML</b>.</p>
      <p>This method chunks files using a 'naive' method: </p>
      <p>
      <li>Use vision detection model to split the texts into smaller segments.</li>
      <li>Then, combine adjacent segments until the token count exceeds the threshold specified by 'Chunk token number', at which point a chunk is created.</li></p>`,
      paper: `<p>Only <b>PDF</b> file is supported.</p><p>
      Papers will be split by section, such as <i>abstract, 1.1, 1.2</i>. </p><p>
      This approach enables the LLM to summarize the paper more effectively and to provide more comprehensive, understandable responses. 
      However, it also increases the context for AI conversations and adds to the computational cost for the LLM. So during a conversation, consider reducing the value of ‘<b>topN</b>’.</p>`,
      presentation: `<p>Supported file formats are <b>PDF</b>, <b>PPTX</b>.</p><p>
      Every page in the slides is treated as a chunk, with its thumbnail image stored.</p><p>
      <i>This chunk method is automatically applied to all uploaded PPT files, so you do not need to specify it manually.</i></p>`,
      qa: `
      <p>
      This chunk method supports <b>XLSX</b> and <b>CSV/TXT</b> file formats.
    </p>
    <li>
      If a file is in <b>XLSX</b> format, it should contain two columns
      without headers: one for questions and the other for answers, with the
      question column preceding the answer column. Multiple sheets are
      acceptable, provided the columns are properly structured.
    </li>
    <li>
      If a file is in <b>CSV/TXT</b> format, it must be UTF-8 encoded with TAB as the delimiter to separate questions and answers.
    </li>
    <p>
      <i>
        Lines of texts that fail to follow the above rules will be ignored, and
        each Q&A pair will be considered a distinct chunk.
      </i>
    </p>
      `,
      resume: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
      </p><p>
      Résumés of various forms are parsed and organized into structured data to facilitate candidate search for recruiters.
      </p>
      `,
      table: `<p>Supported file formats are <b>XLSX</b> and <b>CSV/TXT</b>.</p><p>
      Here are some prerequisites and tips:
      <ul>
    <li>For CSV or TXT file, the delimiter between columns must be <em><b>TAB</b></em>.</li>
    <li>The first row must be column headers.</li>
    <li>Column headers must be meaningful terms to aid your LLM's understanding.
    It is good practice to juxtapose synonyms separated by a slash <i>'/'</i> and to enumerate values using brackets, for example: <i>'Gender/Sex (male, female)'</i>.<p>
    Here are some examples of headers:<ol>
        <li>supplier/vendor<b>'TAB'</b>Color (Yellow, Blue, Brown)<b>'TAB'</b>Sex/Gender (male, female)<b>'TAB'</b>size (M, L, XL, XXL)</li>
        </ol>
        </p>
    </li>
    <li>Every row in table will be treated as a chunk.</li>
    </ul>`,
      picture: `
    <p>Image files are supported, with video support coming soon.</p><p>
    This method employs an OCR model to extract texts from images.
    </p><p>
    If the text extracted by the OCR model is deemed insufficient, a specified visual LLM will be used to provide a description of the image.
    </p>`,
      one: `
    <p>Supported file formats are <b>DOCX, EXCEL, PDF, TXT</b>.
    </p><p>
    This method treats each document in its entirety as a chunk.
    </p><p>
    Applicable when you require the LLM to summarize the entire document, provided it can handle that amount of context length.
    </p>`,
      knowledgeGraph: `<p>Supported file formats are <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>

<p>This approach chunks files using the 'naive'/'General' method. It splits a document into segments and then combines adjacent segments until the token count exceeds the threshold specified by 'Chunk token number', at which point a chunk is created.</p>
<p>The chunks are then fed to the LLM to extract entities and relationships for a knowledge graph.</p>
<p>Ensure that you set the <b>Entity types</b>.</p>`,
      tag: `<p>Knowledge base using 'Tag' as a chunking method is supposed to be used by other knowledge bases to add tags to their chunks, queries to which will also be with tags too.</p>
<p>Knowledge base using 'Tag' as a chunking method is <b>NOT</b> supposed to be involved in RAG procedure.</p>
<p>The chunks in this knowledge base are examples of tags, which demonstrate the entire tag set and the relevance between chunk and tags.</p>

<p>This chunk method supports <b>XLSX</b> and <b>CSV/TXT</b> file formats.</p>
<p>If a file is in <b>XLSX</b> format, it should contain two columns without headers: one for content and the other for tags, with the content column preceding the tags column. Multiple sheets are acceptable, provided the columns are properly structured.</p>
<p>If a file is in <b>CSV/TXT</b> format, it must be UTF-8 encoded with TAB as the delimiter to separate content and tags.</p>
<p>In tags column, there are English <b>comma</b> between tags.</p>
<i>Lines of texts that fail to follow the above rules will be ignored, and each  pair will be considered a distinct chunk.</i>
`,
      useRaptor: 'Use RAPTOR to enhance retrieval',
      useRaptorTip:
        'Recursive Abstractive Processing for Tree-Organized Retrieval, see https://huggingface.co/papers/2401.18059 for more information.',
      prompt: 'Prompt',
      promptTip: 'LLM prompt used for summarization.',
      promptMessage: 'Prompt is required',
      promptText: `Please summarize the following paragraphs. Be careful with the numbers, do not make things up. Paragraphs as following:
      {cluster_content}
The above is the content you need to summarize.`,
      maxToken: 'Max token',
      maxTokenTip: 'Maximum token number for summarization.',
      maxTokenMessage: 'Max token is required',
      threshold: 'Threshold',
      thresholdTip: 'The bigger the threshold is the less cluster will be.',
      thresholdMessage: 'Threshold is required',
      maxCluster: 'Max cluster',
      maxClusterTip: 'Maximum cluster number.',
      maxClusterMessage: 'Max cluster is required',
      randomSeed: 'Random seed',
      randomSeedMessage: 'Random seed is required',
      entityTypes: 'Entity types',
      vietnamese: 'Vietnamese',
      pageRank: 'Page rank',
      pageRankTip: `This increases the relevance score of the knowledge base. Its value will be added to the relevance score of all retrieved chunks from this knowledge base. Useful when you are searching within multiple knowledge bases and wanting to assign a higher pagerank score to a specific one.`,
      tagName: 'Tag',
      frequency: 'Frequency',
      searchTags: 'Search tags',
      tagCloud: 'Cloud',
      tagTable: 'Table',
      tagSet: 'Tag sets',
      tagSetTip: `
     <p> Select one or multiple tag knowledge bases to auto-tag chunks in your knowledge base. </p>
<p>The user query will also be auto-tagged.</p>
This auto-tag feature enhances retrieval by adding another layer of domain-specific knowledge to the existing dataset.
<p>Difference between auto-tag and auto-keyword:</p>
<ul>
  <li>A tag knowledge base is a user-defined close set, whereas keywords extracted by the LLM can be regarded as an open set.</li>
  <li>You must upload tag sets in specified formats before running the auto-tag feature.</li>
  <li>The auto-keyword feature is dependent on the LLM and consumes a significant number of tokens.</li>
</ul>
      `,
      topnTags: 'Top-N Tags',
      tags: 'Tags',
      addTag: 'Add tag',
      useGraphRag: 'Extract knowledge graph',
      useGraphRagTip:
        'Construct a knowledge graph over extracted file chunks to enhance multi-hop question answering.',
      graphRagMethod: 'Method',
      graphRagMethodTip: `Light: (Default) Use prompts provided by github.com/HKUDS/LightRAG to extract entities and relationships. This option consumes fewer tokens, less memory, and fewer computational resources.</br>
        General: Use prompts provided by github.com/microsoft/graphrag to extract entities and relationships`,
      resolution: 'Entity resolution',
      resolutionTip: `An entity deduplication switch. When enabled, the LLM will combine similar entities - e.g., '2025' and 'the year of 2025', or 'IT' and 'Information Technology' - to construct a more accurate graph`,
      community: 'Community reports generation',
      communityTip:
        'In a knowledge graph, a community is a cluster of entities linked by relationships. You can have the LLM generate an abstract for each community, known as a community report. See here for more information: https://www.microsoft.com/en-us/research/blog/graphrag-improving-global-search-via-dynamic-community-selection/',
    },
    chunk: {
      chunk: 'Chunk',
      bulk: 'Bulk',
      selectAll: 'Select All',
      enabledSelected: 'Enable selected',
      disabledSelected: 'Disable selected',
      deleteSelected: 'Delete selected',
      search: 'Search',
      all: 'All',
      enabled: 'Enabled',
      disabled: 'Disabled',
      keyword: 'Keyword',
      function: 'Function',
      chunkMessage: 'Please input value!',
      full: 'Full text',
      ellipse: 'Ellipse',
      graph: 'Knowledge graph',
      question: 'Question',
      questionTip: `If there are given questions, the embedding of the chunk will be based on them.`,
    },
    chat: {
      cancel: 'Annuleren',
      useFormAsAnswer: 'Toon formulier als input',
      useFormAsAnswerTip:
        'Wanneer ingeschakeld, wordt het formulier gebruikt als invoer voor de gebruiker in plaats van een tekstinvoer.',
      formFields: 'Formuliervelden',
      fieldType: 'Type',
      textInput: 'Tekst',
      numberInput: 'Getal',
      emailInput: 'E-mail',
      textareaInput: 'Tekstgebied',
      selectInput: 'Selecteren',
      selectOptions: 'Opties',
      selectOptionsTooltip:
        'Voeg opties toe en beheer ze voor het selectieveld',
      enterOptionText: 'Voer optie tekst in',
      addOption: 'Optie Toevoegen',
      noOptionsAdded: 'Nog geen opties toegevoegd',
      selectDefaultOption: 'Selecteer een standaard optie',
      addOptionsFirst: 'Voeg eerst opties toe',
      noMatchingOptions: 'Geen passende opties',
      required: 'Verplicht',
      forceAnonymize: 'Forceer Anonimiseren',
      forceAnonymizeTooltip:
        'Wanneer ingeschakeld, wordt de waarde van dit veld altijd geanonimiseerd voordat het naar de LLM wordt verzonden, ongeacht automatische PII-detectie.',
      placeholder: 'Placeholder',
      placeholderText: 'Voer placeholder in...',
      options: 'Opties',
      optionsPlaceholder: 'Optie1, Optie2, Optie3',
      optionsTooltip:
        "Voer opties in gescheiden door komma's. Voorbeeld: Ja, Nee, Misschien",
      defaultValue: 'Standaardwaarde',
      defaultValuePlaceholder: 'Voer standaardwaarde in...',
      selectComponent: 'Selecteer component',
      dynamicValue: 'Dynamische Waarde',
      editField: 'Veld Bewerken',
      labelRequired: 'Label is verplicht',
      enterFieldLabel: 'Voer veldlabel in',
      typeRequired: 'Veldtype is verplicht',
      defaultValueSettings: 'Standaardwaarde Instellingen',
      componentIdTooltip:
        'Selecteer een component om de uitvoer als standaardwaarde te gebruiken',
      defaultValueTooltip: 'Voer een vaste standaardwaarde in voor dit veld',
      defaultValueExclusive:
        'Je kunt een component of een vaste standaardwaarde instellen, maar niet beide.',
      untitled: 'Naamloos',
      configuration: 'Configuratie',
      hasPlaceholder: 'Heeft placeholder',
      hasOptions: 'Heeft Opties',
      hasDefaultValue: 'Vaste Standaard',
      hasDynamicDefault: 'Dynamische Standaard',
      edit: 'Bewerken',
      delete: 'Verwijderen',
      jsonPreview: 'JSON Voorbeeld',
      noFieldsForJson: 'Geen formuliervelden om te bekijken',
      formSchema: 'Formulier Schema',
      exampleOutput: 'Voorbeeld Formulier Uitvoer',
      jsonPreviewNote:
        'Dit toont de structuur en voorbeeld uitvoer van je formulier. Dynamische waarden ({{component_id}}) worden tijdens uitvoering opgelost.',
      formPreview: 'Formulier Voorbeeld',
      noFieldsAdded: 'Nog geen formuliervelden toegevoegd',
      selectOption: 'Selecteer een optie',
      fieldRequired: 'Dit veld is verplicht',
      formValidationError: 'Vul alle verplichte velden in',
      formSubmissionError:
        'Fout bij het verzenden van het formulier. Probeer opnieuw.',
      formSubmitted: 'Formulier is succesvol verzonden',
      submitted: 'Verzonden',
      invalidEmail: 'Voer een geldig e-mailadres in',
      submit: 'Verzenden',
      formMessageTitle: 'Vul in',
      makeChoice: 'Maak uw keuze',
      betaVersion: 'Beta versie',
      accessRestricted: 'Toegang beperkt',
      accessRestrictedDescription: 'Je hebt geen toegang tot deze chatsessie.',
      loadingConversationDetails: 'Gesprek laden...',
      backToConversations: 'Terug',
      conversationNotFound: 'Gesprek niet gevonden of toegang geweigerd',
      conversationNotFoundDescription:
        'Het gesprek dat je zoekt bestaat mogelijk niet of je hebt geen toegang om het te bekijken.',
      conversationDetails: 'Gespreksdetails',
      id: 'ID',
      userId: 'Gebruiker ID',
      created: 'Aangemaakt',
      lastMessage: 'Laatste bericht',
      source: 'Bron',
      filteredPersonalIdentifiers: 'Gefilterde persoonlijke gegevens',
      securityNotice: 'Beveiligingsmelding',
      securityNoticeDescription:
        'Persoonlijke gegevens in dit gesprek zijn automatisch gefilterd en vervangen door aanduidingen voor privacy en beveiliging.',
      securityPlaceholder: 'Aanduiding',
      encryptedPersonalIdentifier: 'Versleutelde persoonlijke gegevens',
      assistant: 'Assistent',
      agent: 'Agent',
      information: 'Informatie',
      agentAvatar: 'Agent foto',
      unnamedAgent: 'Naamloze agent',
      description: 'Beschrijving',
      permission: 'Toestemming',
      chat: 'Chat',
      conversationStatistics: 'Statistieken',
      conversationMessages: 'Berichten',
      userMessage: 'Gebruikersbericht',
      assistantResponse: 'Assistent antwoord',
      positiveFeedback: 'Positieve feedback',
      negativeFeedback: 'Negatieve feedback',
      type: 'Type',
      userFeedback: 'Gebruikersfeedback',
      references: 'Referenties',
      unnamedDocument: 'Naamloos document',
      more: 'meer',
      noMessagesFound: 'Geen berichten gevonden in dit gesprek.',
      additionalMetadata: 'Aanvullende informatie',
      selectFeedbackType: 'Kies een optie',
      color: 'Accentkleur',
      launchButtonPing: 'Hoi, ik ben {title}!\nKan ik je ergens mee helpen?',
      openChat: 'Open chat',
      closeChat: 'Sluit chat',
      hoverIcon: 'Toon als zwevend icoon',
      feedback: {
        title: 'Geef Feedback',
        incomplete: 'Onvolledige informatie',
        faulty: 'Onjuiste informatie',
        formatting: 'Vreemde opmaak',
        irrelevant: 'Niet-relevant antwoord',
        verbose: 'Te uitgebreid',
        offensive: 'Ongepaste inhoud',
      },
      inputFeedback: 'Geef je feedback',
      newConversation: 'Nieuw gesprek',
      createAssistant: 'Assistent maken',
      assistantSetting: 'Assistent instellingen',
      promptEngine: 'Prompt engine',
      modelSetting: 'Model instellingen',
      newChat: 'Nieuwe chat',
      send: 'Versturen',
      sendPlaceholder: 'Bericht...',
      chatConfiguration: 'Chat configuratie',
      chatConfigurationDescription:
        'Stel hier een chatassistent in die gekoppeld is aan je kennisbanken! 💕',
      assistantName: 'Naam assistent',
      assistantNameMessage: 'Naam assistent is verplicht',
      namePlaceholder: 'bijv. CV Jarvis',
      assistantAvatar: 'Assistent foto',
      language: 'Taal',
      emptyResponse: 'Leeg antwoord',
      emptyResponseTip:
        'Stel dit in als antwoord wanneer er niets uit de kennisbanken wordt gevonden, of laat leeg zodat de AI kan improviseren.',
      emptyResponseMessage:
        "Een leeg antwoord wordt gebruikt wanneer er geen relevante informatie uit de kennisbanken komt. Maak het veld 'Leeg antwoord' leeg als er geen kennisbank is geselecteerd.",
      setAnOpener: 'Begroeting instellen',
      setAnOpenerInitial: 'Hoi! Ik ben je assistent, hoe kan ik je helpen?',
      setAnOpenerTip: 'Stel een openingsbegroeting in voor gebruikers.',
      knowledgeBases: 'Kennisbanken',
      knowledgeBasesMessage: 'Selecteer een optie',
      knowledgeBasesTip:
        'Kies de kennisbanken die je aan deze chatassistent wilt koppelen.',
      system: 'Systeem prompt',
      systemInitialValue: `Je bent een slimme assistent. Vat de inhoud van de kennisbank samen om de vraag te beantwoorden. Geef een overzicht van de gegevens in de kennisbank en geef een gedetailleerd antwoord. Wanneer alle inhoud van de kennisbank niet relevant is voor de vraag, moet je antwoord de zin bevatten: "Het antwoord dat je zoekt, is niet gevonden in de kennisbank!" Antwoorden moeten rekening houden met de chatgeschiedenis.
  Hier is de kennisbank:
  {knowledge}
  Bovenstaande is de kennisbank.`,
      systemMessage: 'Voer in!',
      systemTip:
        'Je prompts of instructies voor de AI, zoals de rol, gewenste lengte, toon en taal van de antwoorden.',
      topN: 'Top N',
      topNTip:
        "Niet alle tekstfragmenten met een score boven de 'gelijkheidsdrempel' worden naar de AI gestuurd. Dit selecteert de 'Top N' fragmenten uit de opgehaalde gegevens.",
      variable: 'Variabele',
      variableTip:
        "Variabelen helpen bij het ontwikkelen van flexibelere strategieën, vooral bij gebruik van onze chatassistent-API's. Deze variabelen worden gebruikt in de 'Systeem prompt' als onderdeel van de AI-prompts. De variabele {knowledge} is gereserveerd voor de geselecteerde kennisbank(en), en alle variabelen moeten tussen accolades {} staan.",
      add: 'Toevoegen',
      key: 'Sleutel',
      optional: 'Optioneel',
      operation: 'Actie',
      model: 'Model',
      modelTip: 'Taalmodel voor chatten',
      modelMessage: 'Selecteer een optie!',
      freedom: 'Vrijheid',
      improvise: 'Improviseren',
      precise: 'Nauwkeurig',
      balance: 'Balans',
      freedomTip:
        "Een snelkoppeling voor 'Temperatuur', 'Top P', 'Presence penalty' en 'Frequency penalty', die het vrijheidsniveau van het model aangeeft. Kies 'Improviseren' voor creatievere antwoorden; kies 'Nauwkeurig' (standaard) voor conservatievere antwoorden; 'Balans' zit tussen beide in.",
      temperature: 'Temperatuur',
      temperatureMessage: 'Temperatuur is verplicht',
      temperatureTip:
        'Deze parameter bepaalt de willekeurigheid van de modelvoorspellingen. Een lagere temperatuur resulteert in meer conservatieve antwoorden, terwijl een hogere temperatuur creatievere antwoorden oplevert.',
      topP: 'Top P',
      topPMessage: 'Top P is verplicht',
      topPTip:
        'Ook bekend als "nucleus sampling", stelt deze parameter een drempel voor het selecteren van een kleinere set van de meest waarschijnlijke woorden.',
      presencePenalty: 'Presence penalty',
      presencePenaltyMessage: 'Presence penalty is verplicht',
      presencePenaltyTip:
        'Dit ontmoedigt het model om dezelfde informatie te herhalen door woorden die al in het gesprek zijn verschenen te bestraffen.',
      frequencyPenalty: 'Frequentie penalty',
      frequencyPenaltyMessage: 'Frequentie penalty is verplicht',
      frequencyPenaltyTip:
        'Vergelijkbaar met de presence penalty, vermindert dit de neiging van het model om dezelfde woorden vaak te herhalen.',
      maxTokens: 'Max tokens',
      maxTokensMessage: 'Max tokens is verplicht',
      maxTokensTip:
        'Hiermee stel je de maximale lengte van de modeloutput in, gemeten in tokens (woorden of delen van woorden). Standaard is 512. Als je dit uitschakelt, bepaalt het model zelf het aantal tokens.',
      maxTokensInvalidMessage: 'Voer een geldig getal in voor max tokens.',
      maxTokensMinMessage: 'Max tokens kan niet kleiner zijn dan 0.',
      quote: 'Toon citaat',
      quoteTip: 'Of de originele tekst als referentie moet worden weergegeven.',
      selfRag: 'Self-RAG',
      selfRagTip: 'Zie: https://huggingface.co/papers/2310.11511',
      overview: 'Chat ID',
      pv: 'Aantal berichten',
      uv: 'Aantal actieve gebruikers',
      speed: 'Token uitvoersnelheid',
      tokens: 'Aantal verbruikte tokens',
      round: 'Aantal interacties per sessie',
      thumbUp: 'Klanttevredenheid',
      preview: 'Voorbeeld',
      embedded: 'Ingesloten',
      serviceApiEndpoint: 'Service API eindpunt',
      apiKey: 'API sleutel',
      apiReference: 'API documentatie',
      dateRange: 'Datumbereik:',
      backendServiceApi: 'API server',
      createNewKey: 'Nieuwe sleutel maken',
      action: 'Actie',
      embedModalTitle: 'Insluiten in webpagina',
      comingSoon: 'Binnenkort beschikbaar',
      fullScreenTitle: 'Volledig insluiten',
      fullScreenDescription:
        'Voeg de volgende iframe toe aan je website op de gewenste locatie',
      partialTitle: 'Gedeeltelijk insluiten',
      extensionTitle: 'Chrome extensie',
      tokenError: 'Maak eerst een API sleutel aan.',
      betaError:
        'Verkrijg eerst een RAGFlow API sleutel via de systeeminstellingen.',
      searching: 'Zoeken...',
      parsing: 'Parseren',
      uploading: 'Uploaden',
      uploadFailed: 'Upload mislukt',
      regenerate: 'Opnieuw genereren',
      read: 'Lees inhoud',
      tts: 'Tekst naar spraak',
      ttsTip:
        'Zorg ervoor dat je een TTS model selecteert in de instellingen voordat je deze optie inschakelt om tekst als audio af te spelen.',
      relatedQuestion: 'Gerelateerde vraag',
      answerTitle: 'A',
      multiTurn: 'Multi-turn optimalisatie',
      multiTurnTip:
        'Hiermee worden gebruikersvragen geoptimaliseerd met context in een gesprek met meerdere beurten. Wanneer ingeschakeld, verbruikt dit extra AI tokens.',
      howUseId: 'Hoe gebruik je de chat ID?',
      descriptionPlaceholder: "bijv. Een chatassistent voor cv's.",
      useKnowledgeGraph: 'Gebruik knowledge graph',
      useKnowledgeGraphTip:
        'Haalt beschrijvingen van relevante entiteiten, relaties en rapporten op, waardoor complexe vragen beter worden beantwoord.',
      keyword: 'Trefwoord analyse',
      keywordTip:
        'Gebruik AI om gebruikersvragen te analyseren en trefwoorden te extraheren die belangrijk zijn bij de relevantieberekening.',
      languageTip:
        'Maakt het mogelijk om zinnen te herschrijven in de opgegeven taal of standaard naar de laatst gestelde vraag als er geen taal is geselecteerd.',
      avatarHidden: 'Verberg foto',
      locale: 'Taalinstellingen',
      selectLanguage: 'Selecteer een taal',
      reasoning: 'Redenering',
      reasoningTip:
        'Activeert een redeneerproces zoals Deepseek-R1/OpenAI o1, waarbij het model externe kennis kan ophalen wanneer het onzekere informatie tegenkomt.',
      tavilyApiKeyTip:
        'Als hier een API sleutel correct is ingesteld, worden Tavily webzoekopdrachten gebruikt om de kennisbankgegevens aan te vullen.',
      tavilyApiKeyMessage: 'Voer je Tavily API sleutel in',
      tavilyApiKeyHelp: 'Hoe verkrijg je deze?',
      referenceOriginalText: 'Originele tekst',
      viewReferenceImage: 'Bekijk afbeelding',
      viewOriginalDocument: 'Bekijk in origineel document',
      referenceHeader: 'Bron',
      sourceDocuments: 'Bronnen',
      loadingChat: 'Laden...',
      subsidyBuddyQuestionPrompt: 'Stel uw vraag over de EIP-regeling',
      ariaLabels: {
        skipToMessageInput: 'Ga verder naar bericht invoer',
        closeChat: 'Sluit chat',
        assistantTyping: 'Assistent typt een reactie',
        loadingMessageContent: 'Bericht inhoud wordt geladen',
        assistantAvatar: 'Assistent avatar',
        loadingAssistantAvatar: 'Assistent avatar wordt geladen',
        defaultAssistantIcon: 'Standaard assistent icoon',
        assistantComposing: 'Assistent is een reactie aan het samenstellen',
        loadingAnimation: 'Laadanimatie die toont dat de assistent typt',
        assistant: 'Assistent',
        user: 'Gebruiker',
        message: 'bericht',
        messageContentFrom: 'Bericht inhoud van {{sender}}',
        userAvatar: 'Gebruiker avatar',
        assistantMessageActions: 'Assistent bericht acties',
        userMessageActions: 'Gebruiker bericht acties',
        messageContent: '{{sender}} bericht inhoud',
        quickResponseButtons: 'Snelle reactie knoppen',
        availableResponseOptions: 'Beschikbare reactie opties',
        quickResponse: 'Snelle reactie: {{label}}',
        sourceDocumentsReferenced:
          'Brondocumenten waarnaar verwezen wordt in deze reactie',
        sourceDocument: 'Brondocument {{index}}: {{name}}',
        documentsAttached: 'Documenten bijgevoegd bij dit bericht',
        attachedDocument: 'Bijgevoegd document {{index}}: {{name}}',
        viewDocument: 'Bekijk document: {{name}}',
        documentDetails: 'Document details',
        chatInterface: 'Chat Interface',
        chatHeader: 'Chat Header',
        chatAssistantAvatar: 'Chat Assistent Avatar',
        loadingChatAssistant: 'Chat assistent wordt geladen',
        defaultChatAssistantIcon: 'Standaard chat assistent icoon',
        betaVersion: 'Beta versie',
        onlineStatusIndicator: 'Online status indicator',
        chatMessages: 'Chat berichten',
        loadingInitialChatContent: 'Initiële chat inhoud wordt geladen',
        processingMessage: 'Bericht wordt verwerkt',
        messageWithPosition: '{{sender}} bericht {{position}} van {{total}}',
        messageInputArea: 'Bericht invoer gebied',
        quickActionButtons: 'Snelle actie knoppen',
        documentViewer: 'Document weergave',
        copyMessageContent: 'Kopieer bericht inhoud',
        readMessageAloud: 'Lees bericht hardop voor',
        pauseMessageReading: 'Pauzeer bericht voorlezen',
        likeMessage: 'Vind dit een goed antwoord',
        dislikeMessage: 'Vind dit een slecht antwoord',
        likedMessage: 'Bericht geliked',
        dislikedMessage: 'Bericht niet leuk gevonden',
        viewPrompt: 'Bekijk prompt gebruikt voor dit bericht',
        regenerateMessage: 'Genereer bericht opnieuw',
        deleteMessage: 'Verwijder bericht',
        feedbackModalDescription:
          'Deel je feedback over dit antwoord om ons te helpen verbeteren',
        feedbackForm: 'Feedback formulier',
        feedbackTypeSelection: 'Selecteer het type feedback',
        feedbackTextArea: 'Gedetailleerde feedback tekst',
        feedbackTextAreaDescription: 'Geef specifieke details over je feedback',
      },
      field: 'Veld',
      value: 'Waarde',
      shareDeleted: 'Deellink is verwijderd',
    },

    setting: {
      viewFeedback: 'Gebruikersfeedback',
      manageQa: 'Beheer Q&A dataset',
      deleteUser: 'Gebruiker verwijderen',
      deleteUserDescription:
        'Weet je zeker dat je deze gebruiker wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
      accessDenied: 'Je hebt geen toegang tot deze pagina.',
      backHome: 'Terug naar home',
      profile: 'Profiel',
      accountCreated: 'Account aangemaakt',
      profileDescription: 'Upload je foto en pas je profiel aan.',
      createUser: 'Nieuwe gebruiker',
      viewUsers: 'Alle gebruikers',
      viewConversations: 'Gesprekken bekijken',
      avatar: 'Profielfoto',
      language: 'Taal',
      lastLoginTime: 'Laatst ingelogd',
      isAuthenticated: 'Is ingelogd',
      isActive: 'Is actief',
      isSuperuser: 'Beheerder',
      adminTitle: 'Beheerder',
      yes: 'Ja',
      no: 'Nee',
      maxTokens: 'Max tokens',
      maxTokensMessage: 'Max tokens is verplicht',
      maxTokensTip:
        'Dit bepaalt de maximale lengte van het antwoord van het model, gemeten in tokens (woorden of woorddelen). Standaard 512. Als uitgeschakeld, hef je de tokenlimiet op en bepaalt het model zelf de lengte van het antwoord.',
      maxTokensInvalidMessage: 'Voer een geldig getal in voor max tokens.',
      maxTokensMinMessage: 'Max tokens kan niet minder dan 0 zijn.',
      password: 'Wachtwoord',
      passwordDescription:
        'Voer je huidige wachtwoord in om je wachtwoord te wijzigen.',
      model: 'Model providers',
      modelDescription: 'Stel hier de modelparameters en API-sleutel in.',
      team: 'Team',
      system: 'Systeem',
      manageTenants: 'Tenants beheren',
      adminTitle: 'Admin',
      logout: 'Uitloggen',
      api: 'API',
      username: 'Gebruikersnaam',
      usernameMessage: 'Voer je gebruikersnaam in!',
      photo: 'Je foto',
      photoDescription: 'Dit wordt getoond op je profiel.',
      colorSchema: 'Kleurthema',
      colorSchemaMessage: 'Kies je kleurthema!',
      colorSchemaPlaceholder: 'kies je kleurthema',
      bright: 'Licht',
      dark: 'Donker',
      timezone: 'Tijdzone',
      timezoneMessage: 'Voer je tijdzone in!',
      timezonePlaceholder: 'kies je tijdzone',
      email: 'E-mailadres',
      emailDescription: 'E-mail kan niet worden gewijzigd na registratie.',
      currentPassword: 'Huidig wachtwoord',
      currentPasswordMessage: 'Voer je wachtwoord in!',
      newPassword: 'Nieuw wachtwoord',
      newPasswordMessage: 'Voer je wachtwoord in!',
      newPasswordDescription:
        'Je nieuwe wachtwoord moet meer dan 8 tekens bevatten.',
      confirmPassword: 'Bevestig nieuw wachtwoord',
      confirmPasswordMessage: 'Bevestig je wachtwoord!',
      confirmPasswordNonMatchMessage:
        'De ingevoerde wachtwoorden komen niet overeen!',
      cancel: 'Annuleren',
      addedModels: 'Toegevoegde modellen',
      modelsToBeAdded: 'Toe te voegen modellen',
      addTheModel: 'Model toevoegen',
      apiKey: 'API-sleutel',
      apiKeyMessage:
        'Voer de API-sleutel in (bij lokaal geïnstalleerd model negeer je dit).',
      apiKeyTip:
        'De API-sleutel kun je krijgen door je te registreren bij de betreffende LLM-provider.',
      showMoreModels: 'Meer modellen tonen',
      baseUrl: 'Basis-URL',
      baseUrlTip:
        'Als je API-sleutel van OpenAI is, negeer dit dan. Andere providers geven deze basis-URL samen met de API-sleutel.',
      modify: 'Wijzigen',
      systemModelSettings: 'Systeemmodel instellingen',
      chatModel: 'Chatmodel',
      chatModelTip:
        'Het standaard chat-LLM dat alle nieuw aangemaakte kennisbanken zullen gebruiken.',
      embeddingModel: 'Embedding model',
      embeddingModelTip:
        'Het standaard embedding model dat alle nieuw aangemaakte kennisbanken zullen gebruiken.',
      img2txtModel: 'Afbeelding naar tekst model',
      img2txtModelTip:
        "Het standaard multimodale model dat alle nieuw aangemaakte kennisbanken zullen gebruiken. Het kan afbeeldingen of video's beschrijven.",
      sequence2txtModel: 'Spraak naar tekst model',
      sequence2txtModelTip:
        'Het standaard ASR-model dat alle nieuw aangemaakte kennisbanken zullen gebruiken. Dit model zet spraak om naar tekst.',
      rerankModel: 'Herrangschik model',
      rerankModelTip:
        'Het standaard herrangschik model wordt gebruikt om tekstfragmenten te herordenen op basis van gebruikersvragen.',
      ttsModel: 'TTS-model',
      ttsModelTip:
        'Het standaard TTS-model wordt gebruikt om spraak te genereren tijdens gesprekken op verzoek.',
      workspace: 'Werkruimte',
      workspaces: 'Werkruimtes',
      upgrade: 'Upgraden',
      addLlmTitle: 'LLM toevoegen',
      modelName: 'Modelnaam',
      modelID: 'Model ID',
      modelUid: 'Model UID',
      modelNameMessage: 'Voer je modelnaam in!',
      modelType: 'Modeltype',
      modelTypeMessage: 'Voer je modeltype in!',
      addLlmBaseUrl: 'Basis-URL',
      baseUrlNameMessage: 'Voer je basis-URL in!',
      vision: 'Ondersteunt het Vision?',
      ollamaLink: 'Hoe {{name}} integreren',
      FishAudioLink: 'Hoe FishAudio gebruiken',
      TencentCloudLink: 'Hoe TencentCloud ASR gebruiken',
      volcModelNameMessage: 'Voer je modelnaam in!',
      addEndpointID: 'EndpointID van het model',
      endpointIDMessage: 'Voer je EndpointID van het model in',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Voer je ARK_API_KEY in',
      bedrockModelNameMessage: 'Voer je modelnaam in!',
      addBedrockEngineAK: 'ACCESS KEY',
      bedrockAKMessage: 'Voer je ACCESS KEY in',
      addBedrockSK: 'SECRET KEY',
      bedrockSKMessage: 'Voer je SECRET KEY in',
      bedrockRegion: 'AWS-regio',
      bedrockRegionMessage: 'Maak een keuze!',
      'us-east-1': 'VS Oost (N. Virginia)',
      'us-west-2': 'VS West (Oregon)',
      'ap-southeast-1': 'Azië-Pacific (Singapore)',
      'ap-northeast-1': 'Azië-Pacific (Tokyo)',
      'eu-central-1': 'Europa (Frankfurt)',
      'us-gov-west-1': 'AWS GovCloud (VS-West)',
      'ap-southeast-2': 'Azië-Pacific (Sydney)',
      addHunyuanSID: 'Hunyuan Secret ID',
      HunyuanSIDMessage: 'Voer je Secret ID in',
      addHunyuanSK: 'Hunyuan Secret Key',
      HunyuanSKMessage: 'Voer je Secret Key in',
      addTencentCloudSID: 'TencentCloud Secret ID',
      TencentCloudSIDMessage: 'Voer je Secret ID in',
      addTencentCloudSK: 'TencentCloud Secret Key',
      TencentCloudSKMessage: 'Voer je Secret Key in',
      SparkModelNameMessage: 'Kies Spark model',
      addSparkAPIPassword: 'Spark API-wachtwoord',
      SparkAPIPasswordMessage: 'voer je API-wachtwoord in',
      addSparkAPPID: 'Spark APP ID',
      SparkAPPIDMessage: 'voer je APP ID in',
      addSparkAPISecret: 'Spark API Secret',
      SparkAPISecretMessage: 'voer je API Secret in',
      addSparkAPIKey: 'Spark API-sleutel',
      SparkAPIKeyMessage: 'voer je API-sleutel in',
      yiyanModelNameMessage: 'Voer modelnaam in',
      addyiyanAK: 'yiyan API-sleutel',
      yiyanAKMessage: 'Voer je API-sleutel in',
      addyiyanSK: 'yiyan Secret sleutel',
      yiyanSKMessage: 'Voer je Secret sleutel in',
      FishAudioModelNameMessage: 'Geef je spraaksynthese model een naam',
      addFishAudioAK: 'Fish Audio API-sleutel',
      addFishAudioAKMessage: 'Voer je API-sleutel in',
      addFishAudioRefID: 'FishAudio Referentie ID',
      addFishAudioRefIDMessage:
        'Voer de Referentie ID in (laat leeg voor standaardmodel).',
      GoogleModelIDMessage: 'Voer je model ID in!',
      addGoogleProjectID: 'Project ID',
      GoogleProjectIDMessage: 'Voer je Project ID in',
      addGoogleServiceAccountKey:
        'Service Account Key (laat leeg als je Application Default Credentials gebruikt)',
      GoogleServiceAccountKeyMessage:
        'Voer Google Cloud Service Account Key in base64-formaat in',
      addGoogleRegion: 'Google Cloud regio',
      GoogleRegionMessage: 'Voer Google Cloud regio in',
      modelProvidersWarn:
        "Voeg eerst zowel een embedding model als LLM toe in <b>Instellingen > Model providers</b>. Stel ze daarna in bij 'Systeemmodel instellingen'.",
      copyModelProviders: 'Kopiëren vanuit persoonlijke werkruimte',
      copyModelProvidersSuccess: 'Model providers succesvol gekopieerd',
      copyModelProvidersDescription:
        'Kopieer alle instellingen van modelproviders van uw persoonlijke werkruimte naar deze werkruimte. Bestaande configuraties worden vervangen.',
      selectAllModels: 'Alles selecteren',
      clearSelection: 'Selectie wissen',
      selectedModels: '{{count}} model(len) geselecteerd',
      deleteSelectedModels: 'Geselecteerde modellen verwijderen',
      deleteSelectedModelsConfirm:
        'Weet je zeker dat je {{count}} geselecteerde model(len) van {{provider}} wilt verwijderen?',
      apiVersion: 'API-versie',
      apiVersionMessage: 'Voer API-versie in',
      add: 'Toevoegen',
      updateDate: 'Wijzigingsdatum',
      role: 'Rol',
      invite: 'Uitnodigen',
      agree: 'Accepteren',
      refuse: 'Weigeren',
      teamMembers: 'Teamleden',
      joinedTeams: 'Toegetreden teams',
      sureDelete: 'Weet je zeker dat je dit lid wilt verwijderen?',
      quit: 'Verlaten',
      sureQuit: 'Weet je zeker dat je het team wilt verlaten?',
      // Gebruikersbeheer
      isViewer: 'Is kijker',
      actions: 'Acties',
      edit: 'Bewerken',
      editUser: 'Gebruiker bewerken',
      userInfo: 'Gebruikersinfo',
      settingSuccess: 'Instellingen succesvol bijgewerkt',
      settingError: 'Fout bij het bijwerken van instellingen',
      // Toegangsrechten dialogen
      manageDialogAccess: 'Toegang gesprekken beheren',
      manageDialogAccessDescription:
        'Kies van welke assistenten/agents deze kijker de gesprekken kan bekijken',
      availableDialogs: 'Beschikbare agents',
      accessibleDialogs: 'Toegestane agents',
      // Toegangsrechten kennisbanken
      manageKnowledgeBaseAccess: 'Toegang kennisbanken beheren',
      manageKnowledgeBaseAccessDescription:
        'Kies tot welke kennisbanken deze kijker toegang heeft',
      availableKnowledgeBases: 'Beschikbare kennisbanken',
      accessibleKnowledgeBases: 'Toegankelijke kennisbanken',
      viewerPermissionDescription:
        'Kijkers kunnen gesprekken bekijken van de agents',
      conversationMonitor: 'Gesprekken monitor',
      conversationId: 'Gesprek ID',
      agentName: 'Agent Naam',
      unknownAgent: 'Onbekende Agent',
      source: 'Bron',
      rounds: 'Rondes',
      feedback: 'Feedback',
      createdOn: 'Aangemaakt op',
      viewConversation: 'Bekijk Gesprek',
      selectAtLeastOneConversation:
        'Selecteer minimaal één gesprek om te verwijderen',
      failedToDeleteConversations: 'Verwijderen van gesprekken mislukt',
      confirmDeleteConversations:
        'Weet je zeker dat je de geselecteerde gesprekken wilt verwijderen?',
      deleteConversationsWarning: 'Deze actie kan niet ongedaan worden gemaakt',
      yesDelete: 'Ja, verwijderen',
      criteriaText:
        'Criteria: ouder dan {{days}} dag(en), ≤{{rounds}} ronde(s)',
      cutoffDate: 'Afkapbiedatum',
      previewOnlyMessage:
        'Geen gesprekken werden verwijderd. Dit was alleen een voorvertoning',
      successfullyDeleted: 'Succesvol {{count}} gesprekken verwijderd',
      totalFoundMatching: 'Totaal gevonden die voldoen aan criteria',
      olderThanOneDay: 'Ouder dan 1 dag',
      haveOneRoundOrFewer: 'Hebben 1 ronde of minder',
      preview: 'Voorvertoning',
      agentChat: 'Agent/Chat',
      selectAgentChat: 'Selecteer een agent/chat',
      chat: 'Chat',
      agent: 'Agent',
      agentAvatar: 'Agent avatar',
      dateRange: 'Datumbereik',
      startDate: 'Startdatum',
      endDate: 'Einddatum',
      sortBy: 'Sorteer Op',
      newest: 'Nieuwste',
      oldest: 'Oudste',
      mostRounds: 'Meeste rondes',
      fewestRounds: 'Minste rondes',
      mostReceivedFeedback: 'Meeste ontvangen feedback',
      all: 'Alle',
      receivedFeedback: 'Ontvangen feedback',
      selectMinimumFeedbackCount: 'Selecteer minimum feedback aantal',
      selectMinimumRounds: 'Selecteer minimum rondes',
      filter: 'Filter',
      reset: 'Reset',
      deleteSelected: 'Verwijder Geselecteerde',
      selectedConversations: '{{count}} gesprek(ken) geselecteerd',
      activateUser: 'Gebruiker activeren',
      activateUserDescription:
        'Weet je zeker dat je deze gebruiker wilt activeren? Ze zullen weer toegang krijgen tot het platform.',
      deactivateUser: 'Gebruiker deactiveren',
      deactivateUserDescription:
        'Weet je zeker dat je deze gebruiker wilt deactiveren? Ze zullen toegang verliezen tot het platform, maar hun gegevens blijven behouden.',
      userActivatedSuccessfully: 'Gebruiker succesvol geactiveerd',
      userDeactivatedSuccessfully: 'Gebruiker succesvol gedeactiveerd',
    },
    tenant: {
      createTenant: 'Werkruimte aanmaken',
      tenantName: 'Naam werkruimte',
      switchTenant: 'Werkruimte wisselen',
      manageTenants: 'Werkruimten beheren',
      currentTenant: 'Huidige werkruimte',
      switchSuccess: 'Succesvol gewisseld van werkruimte',
      createSuccess: 'Werkruimte succesvol aangemaakt',
      deleteSuccess: 'Werkruimte succesvol verwijderd',
      updateSuccess: 'Werkruimte succesvol bijgewerkt',
      deleteTenant: 'Werkruimte verwijderen',
      deleteConfirm:
        'Weet u zeker dat u deze werkruimte wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
      cannotDeleteLastTenant: 'Kan de enige werkruimte niet verwijderen',
      cannotDeleteOwner: 'Kan de eigenaar van de werkruimte niet verwijderen',
      memberAdded: 'Lid succesvol toegevoegd',
      memberRemoved: 'Lid succesvol verwijderd',
      roleUpdated: 'Rol succesvol bijgewerkt',
      inviteByEmail: 'Uitnodigen per e-mail',
      memberEmail: 'E-mailadres lid',
      memberRole: 'Rol',
      roleOwner: 'Eigenaar',
      roleAdmin: 'Beheerder',
      roleNormal: 'Lid',
      roleViewer: 'Kijker',
      members: 'Leden',
      tenantSettings: 'Instellingen werkruimte',
      noTenantsFound: 'Geen werkruimten gevonden',
      selectTenant: 'Selecteer een werkruimte',
      workspaces: 'Werkruimten',
      addMember: 'Lid toevoegen',
      removeMember: 'Lid verwijderen',
      changeRole: 'Rol wijzigen',
      tenantAvatar: 'Avatar werkruimte',
      notMember: 'U bent geen lid van deze werkruimte',
      switchTooltip: 'Klik om van werkruimte te wisselen',
      activeWorkspace: 'Actieve werkruimte',
      transferOwnership: 'Eigendom overdragen',
      transferOwnershipTitle: 'Eigendom overdragen',
      transferOwnershipDescription:
        'Selecteer een werkruimte om dit item naartoe over te dragen. Deze actie kan niet ongedaan worden gemaakt.',
      selectTargetWorkspace: 'Doelwerkruimte',
      transferOwnershipWarning:
        'U verliest toegang tot dit item na de overdracht.',
      transferOwnershipSuccess: 'Eigendom succesvol overgedragen',
    },
    message: {
      registered: 'Geregistreerd!',
      logout: 'uitgelogd',
      logged: 'logged!',
      pleaseSelectChunk: 'Selecteer een chunk!',
      modified: 'Aangepast',
      created: 'Aangemaakt',
      deleted: 'Verwijderd',
      renamed: 'Hernoemd',
      operated: 'Uitgevoerd',
      updated: 'Bijgewerkt',
      uploaded: 'Geüpload',
      feedback_received: 'Feedback ontvangen',
      200: 'The server successfully returns the requested data.',
      201: 'Create or modify data successfully.',
      202: 'A request has been queued in the background (asynchronous task).',
      204: 'Data deleted successfully.',
      400: 'There was an error in the request issued, and the server did not create or modify data.',
      401: 'Please sign in again.',
      403: 'The user is authorized, but access is prohibited.',
      404: 'The request was made for a record that does not exist, and the server did not perform the operation.',
      406: 'The requested format is not available.',
      410: 'The requested resource has been permanently deleted and will not be available again.',
      413: 'The total size of the files uploaded at once is too large.',
      422: 'When creating an object, a validation error occurred.',
      500: 'A server error occurred, please check the server.',
      502: 'Gateway error.',
      503: 'The service is unavailable and the server is temporarily overloaded or undergoing maintenance.',
      504: 'Gateway timeout.',
      requestError: 'Request error',
      networkAnomalyDescription:
        'There is an abnormality in your network and you cannot connect to the server.',
      networkAnomaly: 'network anomaly',
      hint: 'hint',
    },
    fileManager: {
      name: 'Name',
      uploadDate: 'Upload Date',
      knowledgeBase: 'Knowledge Base',
      size: 'Size',
      action: 'Action',
      addToKnowledge: 'Link to Knowledge Base',
      pleaseSelect: 'Please select',
      newFolder: 'New Folder',
      file: 'File',
      uploadFile: 'Upload File',
      parseOnCreation: 'Parse on creation',
      directory: 'Directory',
      uploadTitle: 'Drag and drop your file here to upload',
      uploadDescription:
        'Supports single or bulk file upload. Files must not exceed 10MB each, with a maximum of 128 files.',
      local: 'Local uploads',
      s3: 'S3 uploads',
      preview: 'Preview',
      fileError: 'File error',
      uploadLimit:
        'Each file must not exceed 10MB, and the total number of files must not exceed 128.',
      destinationFolder: 'Destination folder',
    },
    flow: {
      clearForm: 'Form Clear',
      targetAnswerComponent: 'Formulier om leeg te maken',
      targetAnswerComponentTip:
        'Selecteer het formulier dat je wilt leegmaken als dit component uitgevoerd wordt.',
      clearFormDescription:
        'Wanneer dit component wordt uitgevoerd, worden de waarden van het opgegeven formulier gewist. *Belangrijk:* Je kan wel nog steeds de door de gebruiker ingevoerde waarden gebruiken in de dynamische variabelen in de prompt editor.',
      preserveFormValues: 'Bewaar formulierwaarden',
      selectAnswerComponent: 'Selecteer een antwoord component',
      noAnswerComponentsWithForms:
        'Geen antwoord componenten met formulieren gevonden',
      noMatchingComponents: 'Geen overeenkomende componenten gevonden',
      preserveFormValuesTip:
        'Wanneer ingeschakeld, worden de waarden van het formulier bewaard tussen de rondes.',
      moveUp: 'Omhoog',
      moveDown: 'Omlaag',
      cancel: 'Annuleren',
      enterFormTitle: 'Voer formulier titel in',
      formConfiguration: 'Formulier instellingen',
      formTitle: 'Titel van formulier',
      showCancelButton: 'Toon annuleer knop',
      useFormAsAnswer: 'Toon formulier als input',
      useFormAsAnswerTip:
        'Wanneer ingeschakeld, wordt het formulier gebruikt als invoer voor de gebruiker in plaats van een tekstinvoer.',
      formFields: 'Formuliervelden',
      fieldType: 'Type',
      textInput: 'Tekst',
      numberInput: 'Getal',
      emailInput: 'E-mail',
      textareaInput: 'Tekstgebied',
      selectInput: 'Selecteren',
      selectOptions: 'Opties',
      selectOptionsTooltip:
        'Voeg opties toe en beheer ze voor het selectieveld',
      enterOptionText: 'Voer optie tekst in',
      addOption: 'Optie Toevoegen',
      noOptionsAdded: 'Nog geen opties toegevoegd',
      selectDefaultOption: 'Selecteer een standaard optie',
      addOptionsFirst: 'Voeg eerst opties toe',
      noMatchingOptions: 'Geen passende opties',
      required: 'Verplicht',
      forceAnonymize: 'Forceer Anonimiseren',
      forceAnonymizeTooltip:
        'Wanneer ingeschakeld, wordt de waarde van dit veld altijd geanonimiseerd voordat het naar de LLM wordt verzonden, ongeacht automatische PII-detectie.',
      placeholder: 'Placeholder',
      placeholderText: 'Voer placeholder in...',
      options: 'Opties',
      optionsPlaceholder: 'Optie1, Optie2, Optie3',
      optionsTooltip:
        "Voer opties in gescheiden door komma's. Voorbeeld: Ja, Nee, Misschien",
      defaultValue: 'Standaardwaarde',
      defaultValuePlaceholder: 'Voer standaardwaarde in...',
      selectComponent: 'Selecteer component',
      dynamicValue: 'Dynamische Waarde',
      editField: 'Veld Bewerken',
      labelRequired: 'Label is verplicht',
      enterFieldLabel: 'Voer veldlabel in',
      typeRequired: 'Veldtype is verplicht',
      defaultValueSettings: 'Standaardwaarde Instellingen',
      componentIdTooltip:
        'Selecteer een component om de uitvoer als standaardwaarde te gebruiken',
      defaultValueTooltip: 'Voer een vaste standaardwaarde in voor dit veld',
      defaultValueExclusive:
        'Je kunt een component of een vaste standaardwaarde instellen, maar niet beide.',
      untitled: 'Naamloos',
      configuration: 'Configuratie',
      hasPlaceholder: 'Placeholder',
      hasOptions: 'Opties',
      hasDefaultValue: 'Standaardwaarde',
      hasDynamicDefault: 'Dynamische standaardwaarde',
      edit: 'Bewerken',
      delete: 'Verwijderen',
      jsonPreview: 'JSON Voorbeeld',
      noFieldsForJson: 'Geen formuliervelden om te bekijken',
      formSchema: 'Formulier Schema',
      exampleOutput: 'Voorbeeld Formulier Uitvoer',
      jsonPreviewNote:
        'Dit toont de structuur en voorbeeld uitvoer van je formulier. Dynamische waarden ({{component_id}}) worden tijdens uitvoering opgelost.',
      formPreview: 'Formulier Voorbeeld',
      noFieldsAdded: 'Nog geen formuliervelden toegevoegd',
      selectOption: 'Selecteer een optie',
      fieldRequired: 'Dit veld is verplicht',
      formValidationError: 'Vul alle verplichte velden in',
      formSubmissionError:
        'Fout bij het verzenden van het formulier. Probeer opnieuw.',
      formSubmitted: 'Formulier is succesvol verzonden',
      submitted: 'Verzonden',
      invalidEmail: 'Voer een geldig e-mailadres in',
      submit: 'Verzenden',
      formMessageTitle: 'Vul in',
      excludeLwTrace: 'Trace uitsluiten van LangWatch',
      excludeLwTraceTip:
        'Sluit invoer en gegenereerde uitvoer uit van tracking en registratie in LangWatch. *Let op:* wordt dus niet geregistreerd als trace.',
      forceButtons: 'Verplicht gebruik knoppen',
      forceButtonsTip:
        'Indien ingeschakeld, moeten gebruikers de knoppen gebruiken en kunnen ze geen vrije tekst invoeren.',
      buttons: 'Buttons',
      label: 'Label',
      skipInput: 'Skip input',
      skipInputTip: `When enabled the flow does not wait for input of the user but continious the flow immediately.`,
      filterByTags: 'Filter op tags',
      currentGlobalVariables: 'Huidige globale variabelen',
      pleaseSelect: 'Selecteer of maak een variable',
      globalVariable: 'Globale variabele',
      globalVariableTip:
        'Bewaar de uitvoer van dit component als een globale variabele, die kan worden gebruikt in andere componenten.',
      enableContextSummary: 'Gesprekscontext samenvatting inschakelen',
      enableContextSummaryTip:
        'Wanneer ingeschakeld, destilleert een LLM na elke gespreksbeurt de dialoog tot een beknopte, actuele contextsamenvatting. Deze is opgeslagen in {global:conversation_context} en toegankelijk in elke componentprompt.',
      contextSummaryLlm: 'Model voor contextsamenvatting',
      contextSummaryLlmTip:
        'Het LLM-model dat gebruikt wordt om de gesprekscontextsamenvatting na elke beurt te genereren en bij te werken.',
      contextSummaryMaxTurns: 'Te samenvatten beurten',
      contextSummaryMaxTurnsTip:
        'Het aantal meest recente gespreksberichten dat wordt meegenomen bij het genereren van de contextsamenvatting. Oudere berichten buiten dit venster worden alleen weergegeven via de bestaande samenvatting.',
      debugPanel: 'Debug paneel',
      debugPanelRefresh: 'Vernieuwen',
      conversationContext: 'Gesprekscontext',
      noConversationContext:
        'Nog geen contextsamenvatting. Voer de agent uit om er een te genereren.',
      contextSummaryNotEnabled:
        'Contextsamenvatting is niet ingeschakeld. Schakel "Gesprekscontext samenvatting inschakelen" in via de Begin-node instellingen.',
      executionPath: 'Uitvoerpad',
      noExecutionPath:
        'Nog geen uitvoer opgenomen. Voer de agent uit om te zien welke nodes zijn uitgevoerd.',
      debugMessages: 'Berichtengeschiedenis',
      runningLabel: 'Bezig label',
      runningLabelTip:
        'Deze tekst wordt weergegeven wanneer de agent bezig is met het uitvoeren van dit component.',
      editFlow: 'Bewerk agent',
      enterFlowTitle: 'Voer de naam van de agent in',
      avatar: 'Avatar',
      isRunningText: ' is bezig',
      cite: 'Cite',
      citeTip: 'citeTip',
      name: 'Name',
      nameMessage: 'Please input name',
      description: 'Description',
      examples: 'Examples',
      to: 'To',
      msg: 'Messages',
      messagePlaceholder: 'message',
      messageMsg: 'Please input message or delete this field.',
      addField: 'Add option',
      addMessage: 'Add message',
      loop: 'Loop',
      loopTip:
        'Loop is the upper limit of the number of loops of the current component, when the number of loops exceeds the value of loop, it means that the component can not complete the current task, please re-optimize agent',
      yes: 'Yes',
      no: 'No',
      key: 'Key',
      componentId: 'Component ID',
      add: 'Add',
      operation: 'operation',
      run: 'Run',
      save: 'Opslaan',
      title: 'ID:',
      beginDescription: 'This is where the flow begins.',
      answerDescription: `A component that serves as the interface between human and bot, receiving user inputs and displaying the agent's responses.`,
      retrievalDescription: `A component that retrieves information from specified knowledge bases (datasets). Ensure that the knowledge bases you select use the same embedding model.`,
      generateDescription: `A component that prompts the LLM to generate responses. Ensure the prompt is set correctly.`,
      categorizeDescription: `A component that uses the LLM to classify user inputs into predefined categories. Ensure you specify the name, description, and examples for each category, along with the corresponding next component.`,
      relevantDescription: `A component that uses the LLM to assess whether the upstream output is relevant to the user's latest query. Ensure you specify the next component for each judge result.`,
      rewriteQuestionDescription: `A component that rewrites a user query from the Interact component, based on the context of previous dialogues.`,
      messageDescription:
        "A component that sends out a static message. If multiple messages are supplied, it randomly selects one to send. Ensure its downstream is 'Interact', the interface component.",
      keywordDescription: `A component that retrieves top N search results from user's input. Ensure the TopN value is set properly before use.`,
      switchDescription: `A component that evaluates conditions based on the output of previous components and directs the flow of execution accordingly. It allows for complex branching logic by defining cases and specifying actions for each case or default action if no conditions are met.`,
      wikipediaDescription: `A component that searches from wikipedia.org, using TopN to specify the number of search results. It supplements the existing knowledge bases.`,
      promptText: `Please summarize the following paragraphs. Be careful with the numbers, do not make things up. Paragraphs as following:
        {input}
  The above is the content you need to summarize.`,
      createGraph: 'Nieuwe agent',
      createFromTemplates: 'Create from templates',
      retrieval: 'Retrieval',
      generate: 'Generate',
      answer: 'Interact',
      categorize: 'Categorize',
      relevant: 'Relevant',
      rewriteQuestion: 'Rewrite',
      rewrite: 'Rewrite',
      begin: 'Begin',
      message: 'Message',
      blank: 'Blank',
      createFromNothing: 'Create your agent from scratch',
      addItem: 'Add Item',
      addSubItem: 'Add Sub Item',
      nameRequiredMsg: 'Name is required',
      nameRepeatedMsg: 'The name cannot be repeated',
      keywordExtract: 'Keyword',
      keywordExtractDescription: `A component that extracts keywords from a user query, with Top N specifying the number of keywords to extract.`,
      baidu: 'Baidu',
      baiduDescription: `A component that searches from baidu.com, using TopN to specify the number of search results. It supplements the existing knowledge bases.`,
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'A component that searches from duckduckgo.com, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      channel: 'Channel',
      channelTip: `Perform text search or news search on the component's input`,
      text: 'Text',
      news: 'News',
      messageHistoryWindowSize: 'Message window size',
      messageHistoryWindowSizeTip:
        'The  window size of conversation history that needed to be seen by LLM. The larger the better. But be careful with the maximum content length of LLM.',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      pubMedDescription:
        'A component that searches from https://pubmed.ncbi.nlm.nih.gov/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      email: 'Email',
      emailTip:
        'E-mail is a required field. You must input an E-mail address here.',
      arXiv: 'ArXiv',
      arXivDescription:
        'A component that searches from https://arxiv.org/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      sortBy: 'Sort by',
      submittedDate: 'Submitted date',
      lastUpdatedDate: 'Last updated date',
      relevance: 'Relevance',
      google: 'Google',
      googleDescription:
        'A component that searches from https://www.google.com/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases. Please note that this requires an API key from serpapi.com.',
      bing: 'Bing',
      bingDescription:
        'A component that searches from https://www.bing.com/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases. Please note that this requires an API key from microsoft.com.',
      apiKey: 'API KEY',
      country: 'Country & Region',
      language: 'Language',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'A component that searches https://scholar.google.com/. You can use Top N to specify the number of search results.',
      yearLow: 'Year low',
      yearHigh: 'Year high',
      patents: 'Patents',
      data: 'Data',
      deepL: 'DeepL',
      deepLDescription:
        'A component that gets more specialized translations from https://www.deepl.com/.',
      authKey: 'Auth key',
      sourceLang: 'Source language',
      targetLang: 'Target language',
      gitHub: 'GitHub',
      gitHubDescription:
        'A component that searches for repositories from https://github.com/. You can use Top N to specify the number of search results.',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription:
        'A component that gets specialized translations from https://fanyi.baidu.com/.',
      appid: 'App ID',
      secretKey: 'Secret key',
      domain: 'Domain',
      transType: 'Translation type',
      baiduSecretKeyOptions: {
        translate: 'General translation',
        fieldtranslate: 'Field translation',
      },
      baiduDomainOptions: {
        it: 'Information technology',
        finance: 'Financial and economics',
        machinery: 'Machinery manufacturing',
        senimed: 'Biomedicine',
        novel: 'Online literature',
        academic: 'Academic paper',
        aerospace: 'Aerospace',
        wiki: 'Humanities and social sciences',
        news: 'News and information',
        law: 'Laws and regulations',
        contract: 'Contract',
      },
      baiduSourceLangOptions: {
        auto: 'Auto detect',
        zh: 'Chinese',
        en: 'English',
        yue: 'Cantonese',
        wyw: 'Classical Chinese',
        jp: 'Japanese',
        kor: 'Korean',
        fra: 'French',
        spa: 'Spanish',
        th: 'Thai',
        ara: 'Arabic',
        ru: 'Russian',
        pt: 'Portuguese',
        de: 'German',
        it: 'Italian',
        el: 'Greek',
        nl: 'Dutch',
        pl: 'Polish',
        bul: 'Bulgarian',
        est: 'Estonian',
        dan: 'Danish',
        fin: 'Finnish',
        cs: 'Czech',
        rom: 'Romanian',
        slo: 'Slovenian',
        swe: 'Swedish',
        hu: 'Hungarian',
        cht: 'Traditional Chinese',
        vie: 'Vietnamese',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'A component that retrieves weather information, such as temperature and air quality, from https://www.qweather.com/.',
      lang: 'Language',
      type: 'Type',
      webApiKey: 'Web API key',
      userType: 'User type',
      timePeriod: 'Time period',
      qWeatherLangOptions: {
        zh: 'Simplified Chinese',
        'zh-hant': 'Traditional Chinese',
        en: 'English',
        de: 'German',
        es: 'Spanish',
        fr: 'French',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        ru: 'Russian',
        hi: 'Hindi',
        th: 'Thai',
        ar: 'Arabic',
        pt: 'Portuguese',
        bn: 'Bengali',
        ms: 'Malay',
        nl: 'Dutch',
        el: 'Greek',
        la: 'Latin',
        sv: 'Swedish',
        id: 'Indonesian',
        pl: 'Polish',
        tr: 'Turkish',
        cs: 'Czech',
        et: 'Estonian',
        vi: 'Vietnamese',
        fil: 'Filipino',
        fi: 'Finnish',
        he: 'Hebrew',
        is: 'Icelandic',
        nb: 'Norwegian',
      },
      qWeatherTypeOptions: {
        weather: 'Weather forecast',
        indices: 'Weather life index',
        airquality: 'Air quality',
      },
      qWeatherUserTypeOptions: {
        free: 'Free subscriber',
        paid: 'Paid subscriber',
      },
      qWeatherTimePeriodOptions: {
        now: 'Now',
        '3d': '3 days',
        '7d': '7 days',
        '10d': '10 days',
        '15d': '12 days',
        '30d': '30 days',
      },
      publish: 'API',
      exeSQL: 'ExeSQL',
      exeSQLDescription:
        'A component that performs SQL queries on a relational database, supporting querying from MySQL, PostgreSQL, or MariaDB.',
      dbType: 'Database Type',
      database: 'Database',
      username: 'Username',
      host: 'Host',
      port: 'Port',
      password: 'Wachtwoord',
      switch: 'Switch',
      logicalOperator: 'Logical operator',
      switchOperatorOptions: {
        equal: 'Equals',
        notEqual: 'Not equal',
        gt: 'Greater than',
        ge: 'Greater equal',
        lt: 'Less than',
        le: 'Less equal',
        contains: 'Contains',
        notContains: 'Not contains',
        startWith: 'Starts with',
        endWith: 'Ends with',
        empty: 'Is empty',
        notEmpty: 'Not empty',
      },
      switchLogicOperatorOptions: {
        and: 'AND',
        or: 'OR',
      },
      operator: 'Operator',
      value: 'Value',
      useTemplate: 'Use this template',
      wenCai: 'WenCai',
      queryType: 'Query type',
      wenCaiDescription:
        'A component that obtains financial information, including stock prices and funding news, from a wide range of financial websites.',
      wenCaiQueryTypeOptions: {
        stock: 'stock',
        zhishu: 'index',
        fund: 'fund',
        hkstock: 'Hong Kong shares',
        usstock: 'US stock market',
        threeboard: 'New OTC Market',
        conbond: 'Convertible Bond',
        insurance: 'insurance',
        futures: 'futures',
        lccp: 'Financing',
        foreign_exchange: 'Foreign currency',
      },
      akShare: 'AkShare',
      akShareDescription:
        'A component that obtains news about stocks from https://www.eastmoney.com/.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'A component that queries information about a publicly traded company using its ticker symbol.',
      crawler: 'Web Crawler',
      crawlerDescription:
        'A component that crawls HTML source code from a specified URL.',
      proxy: 'Proxy',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'Content',
      },
      extractType: 'Extract type',
      info: 'Info',
      history: 'History',
      financials: 'Financials',
      balanceSheet: 'Balance sheet',
      cashFlowStatement: 'Cash flow statement',
      jin10: 'Jin10',
      jin10Description:
        'A component that retrieves financial information from the Jin10 Open Platform, including news updates, calendars, quotes, and references.',
      flashType: 'Flash type',
      filter: 'Filter',
      contain: 'Contain',
      calendarType: 'Calendar type',
      calendarDatashape: 'Calendar datashape',
      symbolsDatatype: 'Symbols datatype',
      symbolsType: 'Symbols type',
      jin10TypeOptions: {
        flash: 'Quick News',
        calendar: 'Calendar',
        symbols: 'quotes',
        news: 'reference',
      },
      jin10FlashTypeOptions: {
        '1': 'Market News',
        '2': ' Futures News',
        '3': 'US-Hong Kong News',
        '4': 'A-Share News',
        '5': 'Commodities & Forex News',
      },
      jin10CalendarTypeOptions: {
        cj: 'Macroeconomic Data Calendar',
        qh: ' Futures Calendar',
        hk: 'Hong Kong Stock Market Calendar',
        us: 'US Stock Market Calendar',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Data',
        event: ' Event',
        holiday: 'Holiday',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Commodity Quotes',
        FOREX: ' Forex Quotes',
        FUTURE: 'International Market Quotes',
        CRYPTO: 'Cryptocurrency Quotes',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Commodity List',
        quotes: ' Latest Market Quotes',
      },
      concentrator: 'Concentrator',
      concentratorDescription:
        'A component that receives the output from the upstream component and passes it on as input to the downstream components.',
      deduplication: 'Deduplicatie',
      deduplicationDescription:
        'Een component die de uitvoer van meerdere Retrieval-componenten combineert en dedupliceert, waarbij elk stuk slechts één keer in de uiteindelijke uitvoer verschijnt.',
      jailbreakDetection: 'Jailbreak Detectie',
      jailbreakDetectionDescription:
        'Een component die gebruikersinvoer analyseert op mogelijke jailbreak-pogingen met behulp van patroonherkenning en optionele AI-gestuurde LangWatch evaluatie. Routeert naar verschillende componenten op basis van detectieresultaten.',
      jailbreakStrictness: 'Striktheid',
      jailbreakStrictnessTip:
        'Bepaalt hoe agressief de component controleert op jailbreak-patronen. Laag: controleert alleen duidelijke patronen. Gemiddeld: voegt veelvoorkomende override-pogingen toe. Hoog: bevat alle verdachte patronen.',
      jailbreakStrictnessLow: 'Laag (minimale vals-positieven)',
      jailbreakStrictnessMedium: 'Gemiddeld (gebalanceerd)',
      jailbreakStrictnessHigh: 'Hoog (maximale beveiliging)',
      jailbreakUseLangwatch: 'LangWatch AI Detectie Inschakelen',
      jailbreakUseLangwatchTip:
        'Schakel ML-gebaseerde jailbreak detectie in met LangWatch Azure prompt injection detector. Wordt uitgevoerd na patroon-gebaseerde controles indien ingeschakeld. Biedt extra beveiliging maar zorgt voor 1-2 seconden langere duur.',
      jailbreakUseLangwatchDisabledTip:
        'LangWatch API-sleutel niet geconfigureerd in het canvas. Configureer alstublieft langwatch_api_key in uw agent/canvas-instellingen.',
      jailbreakSafe: 'Veilig',
      jailbreakSafeTip:
        'Het component waarnaar gerouteerd wordt wanneer geen jailbreak-poging is gedetecteerd.',
      jailbreakDetected: 'Jailbreak',
      jailbreakDetectedTip:
        'Het component waarnaar gerouteerd wordt wanneer een jailbreak-poging is gedetecteerd.',
      deduplicationKey: 'Deduplicatiesleutel',
      deduplicationKeyTip:
        'Het veld dat wordt gebruikt om dubbele chunks te identificeren. Kies "Chunk ID" voor de meeste gevallen, "Inhoud" wanneer chunk-ID\'s per bron kunnen verschillen, of "Inhoud met gewicht" voor uitgebreide vergelijking.',
      chunkId: 'Chunk ID',
      contentWithWeight: 'Inhoud met gewicht',
      mergeStrategy: 'Samenvoegstrategie',
      mergeStrategyTip:
        'Hoe duplicaten te behandelen: "Eerste" behoudt het eerste voorkomen (handhaaft volgorde), "Hoogste score" behoudt de chunk met de hoogste gelijkenisscore (optimaliseert kwaliteit).',
      first: 'Eerste',
      highestScore: 'Hoogste score',
      retrievalComponents: 'Retrieval-componenten',
      retrievalComponentsTip:
        'Selecteer de Retrieval-componenten waarvan je de uitvoer wilt samenvoegen en dedupliceren. Alle chunks van de geselecteerde componenten worden gecombineerd en duplicaten worden verwijderd.',
      retrievalComponentsRequired: 'Selecteer minimaal één retrieval-component',
      selectRetrievalComponents:
        'Selecteer retrieval-componenten om samen te voegen',
      minTwoComponentsRequired: 'Selecteer minimaal twee retrieval-componenten',
      duplicateComponentsNotAllowed:
        'U kunt niet dezelfde retrieval-component twee keer selecteren',
      tuShare: 'TuShare',
      tuShareDescription:
        'A component that obtains financial news briefs from mainstream financial websites, aiding industry and quantitative research.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'wallstreetcn',
        '10jqka': 'Straight flush',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Token',
      src: 'Source',
      startDate: 'Start date',
      endDate: 'End date',
      keyword: 'Keyword',
      note: 'Note',
      noteDescription: 'Note',
      notePlaceholder: 'Please enter a note',
      invoke: 'Invoke',
      invokeDescription: `A component capable of calling remote services, using other components' outputs or constants as inputs.`,
      url: 'Url',
      method: 'Method',
      timeout: 'Timeout',
      headers: 'Headers',
      cleanHtml: 'Clean HTML',
      cleanHtmlTip:
        'If the response is HTML formatted and only the primary content wanted, please toggle it on.',
      reference: 'Reference',
      input: 'Input',
      output: 'Output',
      parameter: 'Parameter',
      howUseId: 'How to use agent ID?',
      content: 'Content',
      operationResults: 'Operation Results',
      autosaved: 'Autosaved',
      optional: 'Optional',
      pasteFileLink: 'Paste file link',
      testRun: 'Test Run',
      template: 'Template',
      templateDescription:
        'A component that formats the output of other components.1. Supports Jinja2 templates, will first convert the input to an object and then render the template, 2. Simultaneously retains the original method of using {parameter} string replacement',
      emailComponent: 'Email',
      emailDescription: 'Send an email to a specified address.',
      smtpServer: 'SMTP Server',
      smtpPort: 'SMTP Port',
      senderEmail: 'Sender Email',
      authCode: 'Authorization Code',
      senderName: 'Sender Name',
      toEmail: 'Recipient Email',
      ccEmail: 'CC Email',
      emailSubject: 'Subject',
      emailContent: 'Content',
      smtpServerRequired: 'Please input SMTP server address',
      senderEmailRequired: 'Please input sender email',
      authCodeRequired: 'Please input authorization code',
      toEmailRequired: 'Please input recipient email',
      emailContentRequired: 'Please input email content',
      emailSentSuccess: 'Email sent successfully',
      emailSentFailed: 'Failed to send email',
      dynamicParameters: 'Dynamic Parameters',
      jsonFormatTip:
        'Upstream component should provide JSON string in following format:',
      toEmailTip: 'to_email: Recipient email (Required)',
      ccEmailTip: 'cc_email: CC email (Optional)',
      subjectTip: 'subject: Email subject (Optional)',
      contentTip: 'content: Email content (Optional)',
      jsonUploadTypeErrorMessage: 'Please upload json file',
      jsonUploadContentErrorMessage: 'json file error',
      // Brevo Email Component
      brevoEmail: 'Brevo E-mail',
      brevoEmailDescription:
        'Verstuur transactionele e-mails via de Brevo (voorheen Sendinblue) API. Ondersteunt dynamische inhoud met variabele substitutie.',
      brevoApiConfig: 'API Configuratie',
      brevoApiKey: 'Brevo API Sleutel',
      brevoApiKeyTip:
        'Uw Brevo API sleutel. Verkrijgbaar via het Brevo dashboard onder SMTP & API > API Sleutels.',
      brevoApiKeyRequired: 'Voer uw Brevo API sleutel in',
      brevoApiKeyPlaceholder: 'Voer uw Brevo API sleutel in',
      brevoSenderConfig: 'Afzender Configuratie',
      brevoSenderEmail: 'Afzender E-mail',
      brevoSenderEmailTip:
        'Het e-mailadres dat als afzender wordt weergegeven. Moet geverifieerd zijn in Brevo.',
      brevoSenderEmailRequired: 'Voer het e-mailadres van de afzender in',
      brevoSenderName: 'Afzender Naam',
      brevoSenderNameTip: 'De weergavenaam die als afzender wordt getoond.',
      brevoSenderNameRequired: 'Voer de naam van de afzender in',
      brevoSenderNamePlaceholder: 'bijv. Mijn Bedrijf Notificaties',
      brevoRecipientConfig: 'Ontvanger Configuratie',
      brevoToEmail: 'Ontvanger E-mail',
      brevoToEmailTip:
        'Het e-mailadres van de ontvanger. U kunt variabelen van andere componenten gebruiken zoals {ComponentID}.',
      brevoToEmailRequired: 'Voer het e-mailadres van de ontvanger in',
      brevoToName: 'Ontvanger Naam',
      brevoToNameTip:
        'De weergavenaam van de ontvanger. U kunt variabelen van andere componenten gebruiken.',
      brevoCcEmail: 'CC E-mail',
      brevoCcEmailTip:
        'Carbon copy e-mailadres. Optioneel. U kunt variabelen van andere componenten gebruiken.',
      brevoCcName: 'CC Naam',
      brevoCcNameTip: 'Carbon copy weergavenaam. Optioneel.',
      brevoEmailContent: 'E-mail Inhoud',
      brevoSubject: 'Onderwerp',
      brevoSubjectTip:
        'De onderwerpregel van de e-mail. U kunt variabelen van andere componenten gebruiken.',
      brevoSubjectRequired: 'Voer het onderwerp van de e-mail in',
      brevoHtmlContent: 'HTML Inhoud',
      brevoHtmlContentTip:
        'De HTML body van de e-mail. U kunt variabelen van andere componenten gebruiken en opmaken met HTML tags.',
      brevoTextContent: 'Tekst Inhoud',
      brevoTextContentTip:
        'Platte tekst fallback inhoud. Wordt gebruikt wanneer HTML niet kan worden weergegeven.',
      multipleEmailsTip: "Scheid meerdere adressen met komma's.",
      multipleEmailsInfo:
        "Meerdere e-mails: U kunt één of meerdere e-mailadressen gescheiden door komma's invoeren.",
      iteration: 'Iteration',
      iterationDescription: `This component firstly split the input into array by "delimiter".
Perform the same operation steps on the elements in the array in sequence until all results are output, which can be understood as a task batch processor.

For example, within the long text translation iteration node, if all content is input to the LLM node, the single conversation limit may be reached. The upstream node can first split the long text into multiple fragments, and cooperate with the iterative node to perform batch translation on each fragment to avoid reaching the LLM message limit for a single conversation.`,
      delimiterTip: `
This delimiter is used to split the input text into several text pieces echo of which will be performed as input item of each iteration.`,
      delimiterOptions: {
        comma: 'Comma',
        lineBreak: 'Line break',
        tab: 'Tab',
        underline: 'Underline',
        diagonal: 'Forward slash',
        minus: 'Dash',
        semicolon: 'Semicolon',
      },
      addVariable: 'Variabele toevoegen',
      addComponent: 'Component toevoegen',
      variableSettings: 'Variabele-instellingen',
      globalVariables: 'Global variables',
      systemPrompt: 'System prompt',
      addCategory: 'Add category',
      categoryName: 'Category name',
      nextStep: 'Next step',
      datatype: 'MINE type of the HTTP request',
      insertVariableTip: `Enter / Insert variables`,
      settings: {
        upload: 'Uploaden',
        photo: 'Afbeelding',
        permissions: 'Toestemming',
        permissionsTip: 'Je kan de toestemming van teamleden hier instellen.',
        me: 'ik',
        team: 'Team',
        enterTags: 'Voer tags in',
        langwatchApiKey: 'Langwatch API key',
        langwatchApiKeyTip:
          'Enter a Langwatch project API key to enable agent interaction tracking, prompt version control, and evaluation through LangWatch. Create a seperate project in LangWatch for each agent. API key can be found at "Settings" > "Setup"',
      },
    },
    footer: {
      profile: 'All rights reserved @ React',
    },
    layout: {
      file: 'file',
      knowledge: 'knowledge',
      chat: 'chat',
    },
    feedback: {
      // Migration related
      migrateFeedbackTitle: 'Feedback migreren',
      migrateFeedbackContent:
        'Dit zal alle feedback van gesprekken migreren naar de speciale feedbacktabel. Deze operatie kan enige tijd duren. Weet je zeker dat je wilt doorgaan?',
      yesMigrate: 'Ja, migreren',
      migrationCompleted:
        'Migratie voltooid! {{migrated}} feedbackrecords gemigreerd van {{processed}} gesprekken.',
      migrationFailed: 'Migratie mislukt',
      migrationFailedRetry: 'Migratie mislukt. Probeer het opnieuw.',
      migrating: 'Bezig met migreren...',

      // Status messages
      statusUpdatedSuccessfully: 'Status succesvol bijgewerkt',
      failedToUpdateStatus: 'Status bijwerken mislukt',
      pleaseSelectFeedbackItems: 'Selecteer feedbackitems om bij te werken',
      bulkUpdateSuccess: 'Succesvol {{count}} feedbackitems bijgewerkt',
      bulkUpdateFailed: 'Sommige feedbackitems bijwerken mislukt',
      commentUpdatedSuccessfully: 'Opmerking succesvol bijgewerkt',
      failedToUpdateComment: 'Opmerking bijwerken mislukt',

      // Access control
      onlyAllowedForAdmins: 'Alleen toegestaan voor beheerders',

      // Table columns
      agentChat: 'Agent/Chat',
      feedback: 'Feedback',
      message: 'Bericht',
      status: 'Status',
      adminComments: 'Opmerking',
      assignedTo: 'Toegewezen aan',
      created: 'Aangemaakt',
      view: 'Bekijken',
      actions: 'Acties',
      feedbackType: 'Type',

      // Feedback values
      positive: '👍 Positief',
      negative: '👎 Negatief',
      neutral: 'Neutraal',

      // Status values
      pending: 'Nieuw',
      inProgress: 'Bezig',
      implemented: 'Verwerkt',
      rejected: 'Afgewezen',

      // Modal titles
      editAdminComment: 'Opmerking bewerken',
      addAdminComment: 'Opmerking toevoegen',
      save: 'Opslaan',
      enterAdminComment: 'Voer opmerking in...',

      // Filters and buttons
      filterByThumbUp: 'Postief/negatief',
      filterByStatus: 'Status',
      clearFilters: 'Filters wissen',
      refresh: 'Vernieuwen',
      migrateFeedback: 'Feedback migreren',
      filterByDialogId: 'Filter op agent/chat',
      filterByFeedbackType: 'Type',

      // Bulk actions
      itemsSelected: '{{count}} item(s) geselecteerd:',
      setToPending: 'Instellen op nieuw',
      setToInProgress: 'Instellen op bezig',
      setToImplemented: 'Instellen op verwerkt',
      setToRejected: 'Instellen op afgewezen',
      clearSelection: 'Selectie wissen',

      // Tooltips
      viewConversation: 'Gesprek bekijken',
      viewDetails: 'Details bekijken',

      // Modal
      feedbackDetails: 'Feedback Details',
      feedbackInformation: 'Feedback Informatie',
      conversationContext: 'Gesprekscontext',
      user: 'Gebruiker',
      assistant: 'Assistent',
      loadingConversation: 'Gesprek laden...',
      conversationMessageNotFound: 'Gespreksbericht niet gevonden',
      viewFullConversation: 'Volledig Gesprek Bekijken',
      close: 'Sluiten',
      updated: 'Bijgewerkt',
      enterAdminComments: 'Voer admin opmerkingen in...',
      feedbackUpdated: 'Feedback succesvol bijgewerkt',
      updateFailed: 'Feedback bijwerken mislukt',

      // Pagination
      feedbackRecordsRange: '{{start}}-{{end}} van {{total}} feedbackrecords',
    },
    qa: {
      title: 'Q&A Dataset beheren',
      description:
        'Bekijk en beheer Q&A chunks uit je kennisbank voor RAG agents',
      selectKbAndDocFirst: 'Selecteer eerst een kennisbank en document',
      deleteFailed: 'Verwijderen van Q&A chunk mislukt',
      bulkDeleteFailed: 'Verwijderen van Q&A chunks mislukt',
      bulkEnableFailed: 'Inschakelen van Q&A chunks mislukt',
      bulkDisableFailed: 'Uitschakelen van Q&A chunks mislukt',
      toggleStatusFailed: 'Status van Q&A chunk wijzigen mislukt',
      duplicateQuestion:
        'Een Q&A chunk met deze exacte vraag bestaat al in de kennisbank',
      saveFailed: 'Opslaan van Q&A chunk mislukt',
      importFailed: 'Importeren van Q&A chunks mislukt',
      exportSuccess: '{{count}} Q&A chunks geëxporteerd',
      exportFailed: 'Exporteren van Q&A chunks mislukt',
    },
    knowledgeBase: {
      transferIndexedWarning:
        'Deze kennisbank heeft geïndexeerde inhoud. Overdracht kan mislukken totdat alle chunks zijn verwijderd.',
    },
    admin: {
      tenants: 'Werkruimtes',
      manageTenants: 'Werkruimtes beheren',
      editTenant: 'Werkruimte Bewerken',
      deleteTenant: 'Werkruimte Verwijderen',
      tenantName: 'Werkruimte Naam',
      owner: 'Eigenaar',
      memberCount: 'Leden',
      llmModel: 'LLM-model',
      embeddingModel: 'Embedding-model',
      asrModel: 'ASR-model',
      imageToTextModel: 'Afbeelding naar Tekst Model',
      rerankModel: 'Herrangschik-model',
      ttsModel: 'TTS-model (Optioneel)',
      creditBalance: 'Tegoed',
      totalTenants: 'Totaal Werkruimtes',
      activeStatus: 'Actief',
      inactiveStatus: 'Inactief',
      confirmDeleteTenant:
        'Weet je zeker dat je deze werkruimte wilt verwijderen?',
      deleteWarning:
        'Deze actie markeert de werkruimte als inactief. Gegevens blijven behouden.',
      tenantDeleted: 'Werkruimte succesvol verwijderd',
      tenantUpdated: 'Werkruimte succesvol bijgewerkt',
      failedToUpdateTenant: 'Fout bij het bijwerken van werkruimte',
      noTenantsFound: 'Geen werkruimtes gevonden',
      searchTenants: 'Zoek werkruimtes op naam...',
      createdAt: 'Aangemaakt',
      updatedAt: 'Bijgewerkt',
      actions: 'Acties',
      edit: 'Bewerken',
      delete: 'Verwijderen',
      tenantDeletedSuccessfully: 'Werkruimte succesvol verwijderd',
      tenantUpdatedSuccessfully: 'Werkruimte succesvol bijgewerkt',
      confirmDeleteTitle: 'Werkruimte verwijderen',
      deleteTenantConfirmTitle: 'Werkruimte Verwijderen',
      deleteTenantConfirmMessage:
        'Weet je zeker dat je deze werkruimte wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
      failedToDeleteTenant: 'Fout bij het verwijderen van werkruimte',
      editTenantForm: 'Werkruimte-informatie Bewerken',
      tenantNameLabel: 'Werkruimte Naam',
      tenantNamePlaceholder: 'Voer werkruimte naam in',
      llmModelLabel: 'LLM-model',
      embeddingModelLabel: 'Embedding-model',
      notAllowed: 'Alleen toegestaan voor beheerders',
      permissionDenied: 'Je hebt geen toestemming om deze pagina te openen',
      optional: 'Optioneel',
    },
  },
};
